// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2 2V12C2 13.1 2.9 14 4 14H14',
  'M 5.2 9.3 L 7.04 7.46 C 7.35 7.15 7.85 7.15 8.16 7.46 L 9.54 8.84 C 9.85 9.15 10.35 9.15 10.66 8.84 L 13.65 5.85',
];
